module.exports = __webpack_public_path__ + "static/media/insta-1.b0570e3e.png";